const copyObject = <T>(object: T): T => JSON.parse(JSON.stringify(object));

export default copyObject;